import { LoginForm } from "../_components/Forms/LoginForm/LoginForm";

const LoginPage = () => {
  return (
    <>
      <div className="login container">
        <div className="content row">
          <div className="loginBox">
            <div className="container-login100">
              <LoginForm />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { LoginPage };
